import { getInsurerLogo } from '@osago/ui/insurerLogos';

const ALIASES: Record<string, string> = {
  helios: 'gelios',
  verna: 'gelios',
  alfa: 'alpha',
  // коды СК ипотеки (polis.online) → наши коды: реестр insurers их не знает (DEV-510)
  ingoss: 'ingos',
  maks: 'makc',
  astro_volga: 'astrovolga',
  liberty: 'sovcombank',
  akbars: 'barsstrah',
  'alpha-bank': 'alpha',
  'alpha-retail': 'alpha',
  'rgs-bank-canal': 'rgs',
};

/** Названия ипотечных СК, которых нет в реестре insurers — из GET /companies?type=mortgage */
const PARTNER_TITLES: Record<string, string> = {
  barsstrah: 'Ак Барс Страхование',
  rshbstrah: 'РСХБ-Страхование',
  amt: 'АМТ Страхование',
  psb: 'ПСБ Страхование',
};

export const normalizeCompanyCode = (code: string): string => {
  if (!code) return '';
  const lower = code.toLowerCase();
  return ALIASES[lower] || lower;
};

export const getPartnerCompanyTitle = (code: string): string | undefined =>
  PARTNER_TITLES[normalizeCompanyCode(code)];

export const getCompanyLogo = (code: string): string | undefined => {
  const normalized = normalizeCompanyCode(code);
  return normalized ? getInsurerLogo(normalized) : undefined;
};
